export const universal_voucher_services_insert = {
    universal_voucher_queue_short: {
        code: 'universal_voucher_queue_short',
        ru_name:
            'Постановка на очередь детей дошкольного возраста (до 6 лет) для получения ваучера',
        kk_name:
            'Мектепке дейінгі (6 жасқа дейін) жастағы балаларды ваучер алу үшін кезекке қою',
        ru_text: 'Встать в очередь',
        kk_text: 'Кезекке тұру'
    },
    check_queue_number: {
        url: 'check-queue-number',
        ru_name: 'ПРОВЕРКА НОМЕРА В ОЧЕРЕДИ',
        kk_name: 'КЕЗЕКТЕГІ НӨМІРДІ ТЕКСЕРУ',
        ru_text: 'Проверить очередь',
        kk_text: 'Кезектегі нөмірді тексеру'
    }
};
